import { Box, Button, Drawer, Hidden, IconButton, MenuItem, Typography } from '@material-ui/core';
import DarkModeIcon from '@material-ui/icons/Brightness3';
import MenuIcon from '@material-ui/icons/Menu';
import LightModeIcon from '@material-ui/icons/WbSunny';
import clsx from 'clsx';
import { Link } from 'components';
import { useAuth } from 'context/AuthContext';
import { useSettings } from 'context/SettingsContext';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { menuItems } from '../../menu-items';
import { useStyles } from './header-menu-mobile.style';

export const HeaderMenuMobile = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { openModal, isLoggedIn } = useAuth();
    const { isDarkMode, toggleTheme } = useSettings();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <Hidden mdUp>
            <IconButton onClick={() => setMobileMenuOpen(true)}>
                <MenuIcon />
            </IconButton>
            <Drawer
                anchor="right"
                open={mobileMenuOpen}
                onClose={() => setMobileMenuOpen(false)}
                className={classes.drawer}
            >
                <Box className={classes.menu}>
                    {!isLoggedIn && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setMobileMenuOpen(false);
                                openModal();
                            }}
                            className={classes.button}
                        >
                            <Typography> {t('header:login')}</Typography>
                        </Button>
                    )}
                    {menuItems.map((item, i) => (
                        <Link key={i} to={item.route}>
                            <MenuItem
                                onClick={() => setMobileMenuOpen(false)}
                                className={clsx(
                                    item.matchingRoutes.some((route) => window.location.pathname === route) &&
                                        classes.selected,
                                )}
                            >
                                {t(`header:${item.name}`)}
                            </MenuItem>
                        </Link>
                    ))}
                    {!isLoggedIn && (
                        <MenuItem onClick={toggleTheme}>
                            <IconButton size="small" onClick={toggleTheme} className={classes.icon}>
                                {isDarkMode ? (
                                    <LightModeIcon style={{ fill: 'orange' }} />
                                ) : (
                                    <DarkModeIcon style={{ transform: 'rotate(45deg) translate(3px, 0px)' }} />
                                )}
                            </IconButton>
                            {isDarkMode ? t('header:lightTheme') : t('header:darkTheme')}
                        </MenuItem>
                    )}
                </Box>
            </Drawer>
        </Hidden>
    );
};
